'use client';

import { isWtGamesAppUserAgent } from '@/features/games-app-bridge/shared/helpers/is-wt-games-app-user-agent';

export function useIsWTGamesApp() {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }
  return isWtGamesAppUserAgent(navigator.userAgent);
}
